const handleWebLogout = () => {
  if (window) {
    window.location.reload();
  }
};

export const Util = {
  handleWebLogout,
};
